(function () {
  'use strict';

  var revealSections = [];

  function collectRevealSections() {
    revealSections = Array.prototype.slice.call(
      document.querySelectorAll('[data-dodi-scroll-reveal]')
    );
  }

  function updateRevealSections() {
    var vh = window.innerHeight;
    // Progress reaches 0 while the section is still below the fold, and
    // reaches 1 well before it's scrolled fully past — so the two photos
    // are fully parted by the time the section is roughly centered.
    var start = vh * 0.85;
    var end = vh * 0.2;

    revealSections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      var progress = (start - rect.top) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      section.style.setProperty('--dodi-reveal-progress', progress);
    });
  }

  var ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateRevealSections();
      ticking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    collectRevealSections();
    updateRevealSections();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  });

  // Re-scan when merchants add/reorder sections in the theme editor.
  document.addEventListener('shopify:section:load', function () {
    collectRevealSections();
    updateRevealSections();
  });
})();
